import { useNavigate } from "react-router-dom";
import { API_URL } from "./config";
import { ParseToken } from "./functions"; // Assume getCookie is defined to get cookies
import axios from "axios";
import { getCookie } from "./cookie";
import toast from "react-hot-toast";

export const basicAuth = "";
export const getUrl = (endpoint) => API_URL + endpoint;

axios.interceptors.request.use(async function (config) {
  return config;
});

axios.interceptors.response.use(
  async (response) => {
    document.title = "Complaint Management System";
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if we get a 401 error and ensure it is not a retry
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Attempt to refresh the access token using the refresh token
        const refreshToken = getCookie("refreshToken");
        const refreshResponse = await axios.get(getUrl("/auth/refresh"), {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        });

        if (refreshResponse.status === 200) {
          // Update token in localStorage
          const newToken = refreshResponse?.data?.access_token;
          // console.log("newToken", refreshResponse);
          localStorage.setItem("token", `Bearer ${newToken}`);

          // Retry the original request with the new token
          originalRequest.headers["Authorization"] = ` ${newToken}`;
          return axios(originalRequest);
        }
      } catch (refreshError) {
        // If refreshing fails, log out and clear localStorage
        console.log("refreshError", refreshError);
        toast.error(refreshError?.message);
        if (refreshError.status !== 200) {
          localStorage.clear();
          window.location.href = "/auth/sign-in";
        }
        throw refreshError;
      }
    }

    // Handle other errors
    if (error.response && error.response.data) {
      const errorMessage =
        error.response.data.message || error.response.data.detail;
      throw {
        message: errorMessage,
        status: error.response.status,
      };
    }

    throw error;
  }
);

export const loginHeader = {
  "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
};

export const commonHeader = {
  "Content-Type": "application/json",
};
export const commonHeader2 = {
  "Content-Type": "multipart/form-data",
};

export const getApi = (endpoint, otherHeaders = {}) => {
  return axios.get(getUrl(endpoint), {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const postApi = (endpoint, data, otherHeaders = {}) => {
  return axios.post(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const getApiwith = (endpoint, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token")
  );
  return axios.get(getUrl(endpoint));
};

export const post2Api = (endpoint, data, otherHeaders = {}) => {
  return axios.post(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const postApiWithUrl = (url, data, otherHeaders = {}) => {
  return axios.post(url, data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const patch = (endpoint, data, otherHeaders = {}) => {
  return axios.patch(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};
export const patchWithToken = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.patch(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const getWithToken = (endpoint, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.get(getUrl(endpoint), {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const getWithUrl = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = "";
  return axios.get(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const getWithNewUrl = (url, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.get(url, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const postWithToken = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.post(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};
export const postImageWithToken = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.post(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};
export const postFormDataWithToken = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.post(getUrl(endpoint), data, {
    headers: { ...commonHeader2, ...otherHeaders },
  });
};

export const postWithUrl = (url, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.post(url, data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const postWithNewUrl = (url, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token") || basicAuth
  );
  return axios.post(url, data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const putWithToken = (endpoint, data, otherHeaders = {}) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token")
  );
  return axios.patch(getUrl(endpoint), data, {
    headers: { ...commonHeader, ...otherHeaders },
  });
};

export const deleteWithToken = async (endpoint) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token")
  );
  return axios({
    url: getUrl(endpoint),
    method: "DELETE",
  });
};
export const deleteWithTokenAndData = async (endpoint, payload) => {
  axios.defaults.headers.common["authorization"] = ParseToken(
    localStorage.getItem("token")
  );

  return axios({
    url: getUrl(endpoint),
    method: "DELETE",
    data: payload, // Add the payload here
  });
};
